/**
 * Lightweight environment-aware logger.
 *
 * We deliberately avoid pulling in a full logging library. In development we
 * forward to `console.*` so devs still see stack traces in DevTools. In
 * production builds these become no-ops so the browser console stays clean
 * and we do not leak internal error shapes to end users.
 */
const isProd = process.env.NODE_ENV === "production";

export const logger = {
  info: (...args) => {
    if (!isProd) console.info(...args);
  },
  warn: (...args) => {
    if (!isProd) console.warn(...args);
  },
  error: (...args) => {
    // Keep errors visible even in production so Sentry-style tools or the
    // browser Issue tab can still capture them if the host wires one up.
    console.error(...args);
  },
};

export default logger;
